import FieldPairComponent from "./shared/FieldPairComponent";
import MediaViewComponent from "./shared/MediaViewComponent";

const WatchVideoComponent = ({ data }) => {
  return (
    <MediaViewComponent data={data}>
      <FieldPairComponent label="Video URL">
        <span className="field-value">{data?.url}</span>
      </FieldPairComponent>
      <FieldPairComponent label="Min. Duration">
        <span className="field-value">{data?.min_duration} seconds</span>
      </FieldPairComponent>
    </MediaViewComponent>
  );
};

export default WatchVideoComponent;
